import React, { useRef, useEffect, useState, ReactElement, FC } from 'react'
import classNames from 'classnames'
import useOnclickOutside from 'react-cool-onclickoutside'
import scrollIntoView from 'scroll-into-view-if-needed'

type DropdownProps = {
  up?: boolean
  right?: boolean
  className?: string
  trigger: ReactElement
  hideOnLinkClick?: boolean
  children: React.ReactNode
}

const Dropdown: FC<DropdownProps> = ({
  up,
  right,
  className = '',
  trigger,
  children,
  hideOnLinkClick = true,
}) => {
  const [isOpen, setOpen] = useState(false)
  const [isMenuMounted, setMenuMounted] = useState(false)

  const ref = useOnclickOutside(() => {
    if (isOpen) {
      hide()
    }
  })

  const onToggleClick = () => {
    if (isOpen) {
      hide()
    } else {
      open()
    }
  }

  const hide = () => {
    setOpen(false)
    setMenuMounted(false)
  }

  const open = () => {
    setOpen(true)
  }

  const handleContentClick = e => {
    if (hideOnLinkClick && e.target.closest('a')) {
      hide()
    }
  }

  const handleMenuMount = () => {
    setMenuMounted(true)
  }

  return (
    <div
      ref={ref}
      className={classNames('dropdown', className, {
        'is-up': up,
        'is-right': right,
        'is-active': isOpen && isMenuMounted,
      })}
    >
      <div className="dropdown-trigger" onClick={() => onToggleClick()}>
        {trigger}
      </div>
      {isOpen && (
        <Menu onClick={handleContentClick} onMount={handleMenuMount}>
          {children}
        </Menu>
      )}
    </div>
  )
}

const Menu = ({ children, onClick, onMount }) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    onMount()
    ref.current &&
      scrollIntoView(ref.current, {
        scrollMode: 'if-needed',
      })
  }, [])

  return (
    <div className="dropdown-menu">
      <div className="dropdown-content" onClick={onClick} ref={ref}>
        {children}
      </div>
    </div>
  )
}

export default Dropdown
